import React from "react";
import { useTranslation } from "react-i18next";
import { useMilestoneEdition } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function NameForm({ milestone, hide }: Props) {
  const { t } = useTranslation();
  const [name, setName] = React.useState(milestone.name);
  const { isRequestPending, editMilestone } = useMilestoneEdition(milestone);
  const submit = () => {
    !isRequestPending &&
      editMilestone({
        milestone,
        nextMilestone: {
          ...milestone,
          name,
        },
      });
    hide();
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <input
        className={styles.input}
        placeholder={t("milestoneForm.name")}
        value={name}
        onChange={({ target }) => setName(target.value)}
        onBlur={submit}
        autoFocus
      />
    </form>
  );
}

export { NameForm };
